import { Request } from 'express';

const campaignHosts = ['trial.quillbot.com', 'core.quillbot.dev', 'trial-stage.quillbot.com'];

export function getCampaign(req: Request) {
  const host = (req.headers as any)['qb-original-host'] || req.headers?.host || '';
  if (campaignHosts.includes(host)) {
    return 'ifp';
  }
  return '';
}
